import { useEffect, useState } from "react";
import { Copy, Link2, Users, Wallet } from "lucide-react";
import { Empty, Stat } from "../components/common";
import { api, date, idr } from "../lib/api";
import { WithdrawPanel } from "./WithdrawPanel";
import { Leaderboard } from "./Leaderboard";

export default function Affiliate() {
  const [data, setData] = useState(null);
  const [copied, setCopied] = useState(false);
  useEffect(() => { api.get("/affiliates").then((r) => setData(r.data)); }, []);
  const link = data ? `${window.location.origin}/?ref=${data.code}` : "";
  const copy = () => { navigator.clipboard?.writeText(link); setCopied(true); setTimeout(() => setCopied(false), 2000); };

  return (
    <>
      <div className="page-intro">
        <div><p className="eyebrow">PARTNER PROGRAM</p><h2>Affiliate center</h2><p className="muted">Ajak trader lain dan dapatkan komisi dari setiap sewa EA yang disetujui.</p></div>
        <button className="primary" data-testid="copy-affiliate-button" onClick={copy}><Copy size={16} /> {copied ? "Tersalin!" : "Salin link"}</button>
      </div>
      <div className="affiliate-hero">
        <div>
          <p className="eyebrow">LINK REFERRAL ANDA</p>
          <h3 data-testid="affiliate-link">{link.replace(/^https?:\/\//, "").split("?")[0]}?ref=<em>{data?.code}</em></h3>
          <p className="muted">Komisi {data?.rate || 5}% dari setiap pembayaran sewa EA member referral Anda.</p>
        </div>
        <Link2 size={60} />
      </div>
      <div className="stats-grid three">
        <Stat testId="affiliate-clicks" label="Total klik" value={data?.clicks ?? 0} hint="Kunjungan via link" icon={Link2} />
        <Stat testId="affiliate-members" label="Member referral" value={data?.members ?? 0} hint="Terdaftar dengan kode Anda" icon={Users} />
        <Stat testId="affiliate-commission" label="Total komisi" value={idr(data?.total_commission)} hint={`${data?.rate || 5}% per sewa EA`} icon={Wallet} />
      </div>
      <Leaderboard />
      <WithdrawPanel />
      <section className="panel table-panel mt">
        <div className="panel-head"><h3>Riwayat komisi</h3></div>
        {!data?.commissions?.length ? <Empty testId="commission-empty" icon={Wallet} title="Belum ada komisi" text="Komisi tercatat otomatis saat admin menyetujui pembayaran sewa EA member Anda." /> : (
          <>
            <div className="table-row table-head"><span>TANGGAL</span><span>MEMBER</span><span>PEMBAYARAN</span><span>KOMISI</span></div>
            {data.commissions.map((c) => (
              <div className="table-row" key={c.id} data-testid={`commission-row-${c.id}`}>
                <span>{date(c.created_at)}</span><span>{c.member_name}</span><span>{c.title} · {idr(c.base_amount)}</span><span className="up">{idr(c.amount)}</span>
              </div>
            ))}
          </>
        )}
      </section>
    </>
  );
}
